import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

import { PARTNER_PORTAL_NS } from "../model/portalKeys";
import { usePartnerSuspended } from "../model/usePartnerAccess";

/**
 * 渠道已暂停(OEM 第二批 A6)= 后台只读冻结:终端客户照常使用,渠道这边能看不能改。
 * 渠道后台每个路由顶上挂一条(App 的 PartnerRoute 统一挂),写按钮各页再按 usePartnerWrite 禁用。
 */
export function PartnerSuspendedBanner() {
  const { t } = useTranslation(PARTNER_PORTAL_NS);
  const suspended = usePartnerSuspended();
  if (!suspended) return null;
  return (
    <div
      role="status"
      data-testid="partner-suspended-banner"
      className="mb-4 flex items-center gap-2 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
    >
      <Lock className="h-4 w-4 shrink-0" />
      {t("common.partnerSuspended")}
    </div>
  );
}
